import { createSelector } from 'reselect';

import { RootState } from 'redux/schemas';
import { MentoringProgramNormalized } from 'redux/schemas/models/mentoring-programs';

export const getMentoringProgram = (
  state: RootState,
  programId: number,
) => state.models.mentoringPrograms[programId];

export const getProgramCounts = (state: RootState) => state.app.mentoringProgram.programCounts;

export const getCloningMentoringProgramIds = createSelector(
  (state: RootState) => state.models.mentoringPrograms as Record<number, MentoringProgramNormalized>,
  (mentoringPrograms): number[] => Object.values(mentoringPrograms ?? {})
    .filter((program) => !!program.isBeingCloned)
    .map((program) => program.id),
);

export const getMentoringProgramAliases = createSelector(
  (state: RootState, programId: number) => {
    const { programAlias } = getMentoringProgram(state, programId) ?? {};

    return programAlias;
  },
  (programAlias) => {
    if (!programAlias) {
      return {};
    }

    const { mentee, mentor } = programAlias;

    return {
      // Mentee
      MenteeAlias: mentee?.capitalizedSingularized,
      MenteesAlias: mentee?.capitalizedPluralized,
      menteeAlias: mentee?.downcasedSingularized,
      menteesAlias: mentee?.downcasedPluralized,
      MenteesTitleAlias: mentee?.pluralizedTitleized,
      MenteeTitleAlias: mentee?.singularizedTitleized,
      // Mentor
      MentorAlias: mentor?.capitalizedSingularized,
      MentorsAlias: mentor?.capitalizedPluralized,
      mentorAlias: mentor?.downcasedSingularized,
      mentorsAlias: mentor?.downcasedPluralized,
      MentorsTitleAlias: mentor?.pluralizedTitleized,
      MentorTitleAlias: mentor?.singularizedTitleized,
    };
  },
);

export const getAutoMatchingStatus = (state: RootState) => state.app.mentoringProgram.autoMatching.status;

export const getSettingsSaveStatus = (state: RootState) => state.app.mentoringProgram.settings.saveStatus;
